var Api = {
	loginUser(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/login/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				token: resource.token,
				loginResponse: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	passwordRecovery(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/login/recovery/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				recoveryResponse: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getRecoveryInfo(code, callback) {
		fetch('https://import.exploring-ckdod.com/api/login/recovery/checkCode/?code=' + code, {
			method: 'GET'
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				codeResponse: resource.message
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	passwordChange(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/login/recovery/passwordChange/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				response: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	changeUserSettings(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/account/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				response: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getFiles(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				list: resource.list.results,
				total_results: resource.list.total_results,
				message: resource.message
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	uploadFile(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status,
				name: resource.list.results.name,
				id: resource.list.results.id
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getFileContents(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/content/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				headers: resource.list.results.headers,
				content: resource.list.results.content,
				rawColumns: resource.list.results.rawColumns
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	uploadFileContents(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/save/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				errors: resource.list.results.errors,
				content: resource.list.results.content,
				newPatients: resource.list.results.newPatients,
				updatedPatients: resource.list.results.updatedPatients
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	deleteFile(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/delete/', {
			method: 'DELETE',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	deleteFileContents(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/delete/content/', {
			method: 'DELETE',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	deleteInitialDatabase(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/files/import/delete/all/', {
			method: 'DELETE',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getEgfrFiles(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/egfr/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				list: resource.list.results,
				total_results: resource.list.total_results,
				message: resource.message
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	generateCalculation(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/egfr/calculate/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getUsers(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/users/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				list: resource.list.results,
				total_results: resource.list.total_results,
				message: resource.message
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	getUserInfo(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/users/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				info: resource.list.user_info
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	createNewUser(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/users/new/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				response: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	updateUser(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/users/update/', {
			method: 'POST',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				response: resource.message,
				showPreloader: false,
				errorCode: resource.errorCode
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	deleteUser(data, callback) {
		fetch('https://import.exploring-ckdod.com/api/users/delete/', {
			method: 'DELETE',
			body: data
		}).then(function(response) {
			return response.json();
		}).then(function(resource) {
			var objReturn = {
				status: resource.list.results.status
			}
			callback(objReturn);
		}).catch(function(err) {
			console.log(err);
		});
	},

	parseToken(token, callback) {
		var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var final = decodeURIComponent(Array.prototype.map.call(atob(base64), function(c) {
	        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	    }).join(''));
        callback(JSON.parse(final));
	}
};

export default Api;



// WEBPACK FOOTER //
// ./src/config/Api.js